module.exports = __webpack_public_path__ + "static/media/telegram.8a7bc4c4.svg";